// src/components/game/FeatureIntroMessage.js
import React from 'react';

const FeatureIntroMessage = ({ message }) => {
  if (!message) return null;
  
  return (
    <div className="bg-purple-50 border-l-4 border-purple-500 p-3 mb-4 text-purple-700">
      <div className="flex items-start">
        <div className="text-purple-500 mr-2">✨</div>
        <div>{message}</div>
      </div>
    </div>
  );
};

export default FeatureIntroMessage;